"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPOTInput = void 0;
var React = require("react");
var classnames_1 = require("classnames");
require("./SPOTInput.scss");
var react_i18next_1 = require("react-i18next");
require("../../../resources/icons/style.css");
var ToolTip_1 = require("../../basic/tooltip/ToolTip");
exports.SPOTInput = React.forwardRef(function (props, ref) {
    var _a = React.useState(props.isTouched), touched = _a[0], setTouched = _a[1];
    var error = props.errors && props.errors[props.name];
    var register = props.register;
    var marksTouched = function () {
        setTouched(true);
    };
    var computedValidation = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!props.computedValidation) return [3 /*break*/, 2];
                    return [4 /*yield*/, props.computedValidation(value)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [2 /*return*/, true];
            }
        });
    }); };
    return (React.createElement("div", null,
        React.createElement("div", { className: "input-label-wrapper" },
            props.label && (React.createElement("label", { className: "input-label", htmlFor: props.id },
                React.createElement(react_i18next_1.Translation, null, function (t, _a) {
                    var i18n = _a.i18n;
                    return React.createElement("b", null, t(props.label));
                }))),
            props.modal && React.createElement(ToolTip_1.default, { iconSize: 23, position: "top center", text: props.modal })),
        React.createElement("div", { className: (0, classnames_1.default)({
                "input-field": true,
                "input-success": props.defaultValue && touched && !error,
                "input-error": error
            }) },
            React.createElement("input", __assign({ type: props.type ? props.type : "text", className: props.className, "data-id": props.dataId, maxLength: props.maxLength, id: props.id, disabled: props.disabled }, register(props.name, {
                required: props.required,
                pattern: props.pattern,
                min: props.min,
                max: props.max,
                validate: computedValidation,
                onChange: function (e) {
                    props.onChange(e);
                },
                onBlur: function (e) {
                    marksTouched();
                    if (props.onBlur) {
                        props.onBlur(e);
                    }
                }
            }), { placeholder: "", defaultValue: props.defaultValue, autoFocus: props.autofocus })),
            props.defaultValue && touched && !error && React.createElement("i", { className: "icon-checkmark input-icon" }),
            error && React.createElement("i", { className: "icon-close input-icon" }),
            React.createElement("span", { className: "inputErrorMessage" }, error && error.message))));
});
//# sourceMappingURL=SPOTInput.js.map